/**
 * The `flow` query param names a funnel. Two exist:
 *
 *   - `flow=flow1` — the /pricing ad funnel (Nov 2025): hides the navbar on
 *     /pricing and the search/bottom bar on /cart ("minimal mode").
 *   - `flow=shop`  — a storefront (/shop) visitor on /cart: the same minimal
 *     mode, plus shop-specific back/home targets and no account icons.
 *
 * Read them only through these helpers so the two funnels stay consistent.
 * See docs/storefront/README.md ("Cart flow for shop visitors").
 */
export const FLOW_PRICING = "flow1";
export const FLOW_SHOP = "shop";

const MINIMAL_FLOWS = [FLOW_PRICING, FLOW_SHOP];

/** The `flow` param of a search string ("" when absent). */
export function getFlow(search) {
  return new URLSearchParams(search || "").get("flow") || "";
}

/** Minimal mode (no navbar search/bottom bar): pricing funnel or shop. */
export function isMinimalFlow(search) {
  return MINIMAL_FLOWS.includes(getFlow(search));
}

/** A storefront visitor (arrived at /cart from /shop). */
export function isShopFlow(search) {
  return getFlow(search) === FLOW_SHOP;
}

/**
 * Whether the navbar's account actions (notifications, chat, avatar) are
 * hidden: always for shop visitors (no escape hatch from the cart), and for
 * logged-out users in any minimal flow (the icons only redirected to login).
 * Logged-in pricing-funnel users keep them.
 */
export function shouldHideTopActions({ search, isAuthenticated, isMinimalMode }) {
  return isShopFlow(search) || (!isAuthenticated && Boolean(isMinimalMode));
}
